<template>
    <div class="inner-wrapper">
       <!-- <div class="page-title">
            <h1 class="float-left">Create New RFQ</h1>
            <div class="title-right float-right">
                <router-link :to="{name: 'draft'}" class="btn custom-btn">Drafts <span>{{ settings.draft_count }}</span>
                </router-link>
            </div>
        </div>-->
        <div class="new-rfq">
            <div class="alert alert-success" role="alert" v-if="successMessage">
                {{ successMessage }}
            </div>

            <div class="alert alert-danger" role="alert" v-if="errorMessage">
                {{ errorMessage }}
            </div>

            <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                            {{ error }}
                        </p>
                    </li>
                </ul>
            </div>
            <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
                <form @submit.prevent="handleSubmit(submitHandler)" method="post" id="saveQuoteForm"
                      name="saveQuoteForm">
                    <div class="mb-4 row" v-if="isItReady">
                        <div class="col-lg-3 col-md-3">
                            <div class="card panel left-panel-row">
                                <div class="card-header">
                                    <div class="">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <h5 class="card-title flex-grow-1 mb-0">Quote No.</h5>
                                            <div class="form-group">
                                                <input type="text" placeholder="" v-model="form.quote_number" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="form-group mb-2">
                                        <label>Customer</label>
                                        <!--<v-select label="text" :filterable="false"
                                                  v-model="form.customer_id"
                                                  :options="customers"
                                                  :reduce="customer => customer.id"
                                                  @search="onCustomerSearch"
                                                  @selected="onCustomerSelect"
                                                  @deselected ="onCustomerDeSelect">
                                            <template slot="no-options">
                                                type to search customers..
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center" v-html="option.html">
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center" v-html="option.text">
                                                </div>
                                            </template>
                                        </v-select>-->
                                        <ValidationProvider name="Customer" rules="required" v-slot="{ errors }">
                                            <v-select label="text" :filterable="false"
                                                      v-model="form.customer"
                                                      :options="customers"
                                                      @input="onCustomerSelect"
                                                      @search="onCustomerSearch"
                                                      @selected="onCustomerSelect"
                                                      @deselected="onCustomerDeSelect">
                                                <template slot="no-options">
                                                    type to search customers..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-html="option.html">
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center" v-html="option.text">
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                    <!--<router-link :to="{name: 'addCustomer'}"
                                                 class="btn btn-primary pull-right mb-2">New Customer
                                    </router-link>-->
                                    <a href="javascript:void(0)" data-toggle="modal" data-target="#customerAddModal" class="btn btn-primary pull-right mb-2" style="padding: 5px 10px;">New Customer</a>

                                    <div class="form-group mb-2">

                                        <div class="d-flex align-items-center justify-content-between">
                                            <label style="margin-bottom: 0;">Sales REP</label>

                                        </div>
                                        <ValidationProvider name="Sales REP" rules="required" v-slot="{ errors }">
                                            <select class="form-control" v-model="form.sale_rep">
                                                <option value="null">Select Sale Rep</option>
                                                <option v-for="item in settings.sale_users" :value="item.id">
                                                    {{ item.name }}
                                                </option>
                                            </select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="col-lg-9 col-md-9">


                        <div class="modal" id="importModal">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content border-0">
                                    <div class="modal-header p-3 bg-soft-info">
                                        <h5 class="modal-title" id="importModalLabel">Import Products</h5>
                                        <button type="button" class="close btn-close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                                    </div>
                                    <div class="modal-body">
                                        <div>
                                            <label for="formFile" class="form-label">File *</label>
                                            <input class="form-control" type="file" id="formFile">
                                        </div>
                                        <div class="mt-4">
                                            <label for="formFile" class="form-label d-block">Download SCV</label>
                                            <a href="#" class="btn btn-primary fw-semibold fs-14 px-4">Download Sample.csv</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                            <div class="card panel view-quote-box add-quote-box  mb-4">
                                <div class="card-header header-sec">
                                    <div class="card-header-left header-left">
                                        <h5 class="card-title">Quote Name</h5>
                                        <input type="text" class="form-control newcon" v-model="form.quote_name"
                                               placeholder="Enter Quote Name" style="width: 56%; ">
                                        <!--<ValidationProvider name="Quote Name" rules="required" v-slot="{ errors }">
                                            <input type="text" class="form-control newcon" v-model="form.quote_name"
                                                   placeholder="Enter Quote Name">
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>-->
                                    </div>
                                    <div class="card-header-right header-right">
                                    <!--<a href="javascript:void(0)"   v-on:click="addProduct" class="btn btn-success btn-sm" ><i class="ri-upload-2-fill align-middle me-1"></i> Import</a>-->
                                   <!--<button type="button" class="btn btn-success btn-sm" data-toggle="modal" data-target="#importModal">
                                        <i class="ri-upload-2-fill align-middle me-1"></i> Import
                                    </button>-->
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive product-create">
                                        <table class="table table-custom mb-3">
                                            <thead>
                                            <tr>
                                                <th style="width: 140px;">Item#</th>
                                                <th style="width: 210px;">Name</th>
                                                <th>Description</th>
                                                <th style="width: 120px">Quantity Tier</th>
                                                <th style="width: 150px">SKU</th>
                                                <th style="width: 120px" >Unit</th>
                                                <!--<th>Order Number</th>
                                                <th >Status</th>-->
                                            </tr>
                                            </thead>
                                            <tr v-for="(item, index) in form.products">
                                                <td>
                                                    <div class="form-group product-search-combo">
                                                        <v-select label="product_num" :filterable="false"
                                                                  placeholder="#item"
                                                                  v-model="form.products[index].product"
                                                                  :options="products"
                                                                  @input="onProductSelect($event, index)"
                                                                  @search="onProductSearch"
                                                                  @selected="onProductSelect($event, index)"
                                                                  @deselected="onProductDeSelect">
                                                            <template slot="no-options">
                                                                type to search products..
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center" v-html="option.product_name">
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center"
                                                                     v-html="option.product_num">
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                    </div>
                                                    <div class="form-check" v-if="form.products[index].product_id">
                                                        <label class="form-check-label">
                                                            <input type="checkbox"
                                                                   v-model="form.products[index].is_master_product_modify"
                                                                   class="form-check-input" value=""> Modify the
                                                            original product?
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <ValidationProvider name="Product Name" rules="required"
                                                                            v-slot="{ errors }">
                                                            <input type="text" class="form-control"
                                                                   placeholder="Enter Product"
                                                                   v-model="form.products[index].name">
                                                            <div class="error" v-if="errors.length">{{
                                                                    errors[0]
                                                                }}
                                                            </div>
                                                        </ValidationProvider>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                    <!-- <textarea rows="4" class="form-control"
                                                              v-model="form.products[index].description"></textarea> -->
                                                        <!-- <ckeditor :id="'edit_description_'+index" :key="'edit_description_'+index" v-model="form.products[index].description"
                                                                  type="inline"
                                                                  :config="editorConfigMin"></ckeditor> -->
                                                         <!--<vue-ckeditor :id="'edit_description_'+index" :key="'edit_description_'+index"
                                                                      v-model="form.products[index].description"
                                                                      tag-name="textarea"
                                                                      types="inline"
                                                                      :config="editorConfigMin"></vue-ckeditor>-->

                                                        <!--<vue-ckeditor :id="'edit_description_'+index" :key="'edit_description_'+index"
                                                                      v-model="form.products[index].description"
                                                                      tag-name="textarea"
                                                                      types="inline"
                                                                      :config="editorConfigMin"></vue-ckeditor>-->

                                                        <VueEditor :id="'edit_description_'+index" :key="'edit_description_'+index" v-model="form.products[index].description" :editorOptions="editorConfigMin2"></VueEditor>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <template v-for="(tier, tierIndex) in item.tiers">
                                                            <input type="text" class="form-control" placeholder=""
                                                                   @keyup="tierNumberFormat(index, tierIndex)"
                                                                   v-model="form.products[index].tiers[tierIndex].tier">
                                                        </template>
                                                    </div>
                                                </td>
                                                <td class="unit-col">
                                                    <div class="form-group">
                                                        <template v-for="(tier, tierIndex) in item.tiers">
                                                            <div class="sku-group">
                                                                <input type="text" class="form-control"
                                                                       placeholder=""
                                                                       v-model="form.products[index].tiers[tierIndex].sku">

                                                                <template v-if="tierIndex > 2">
                                                                    <a href="javascript:void(0)"
                                                                       v-on:click="removeTier(index, tierIndex)"
                                                                       class="remove-icon-btn btn btn-danger"><i class="ri-delete-bin-6-line" style="font-size: 18px;"></i></a>
                                                                </template>
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <a href="javascript:void(0)" v-on:click="addNewTier(index)"
                                                       class="add-icon-btn"><i class="ri-add-line" style="font-size: 19px;"></i></a>
                                                </td>
                                                <td >
                                                    <div class="form-group">
                                                        <select class="form-control"
                                                                v-model="form.products[index].quantity_unit">
                                                            <option value="bags">Bags</option>
                                                            <option value="impressions">Impressions</option>
                                                            <option value="kg">Kg</option>
                                                            <option value="lb">Lb</option>
                                                            <option value="pcs">Pcs</option>
                                                            <option value="roll">Roll</option>
                                                            <option value="M Bags">M Bags</option>
                                                            <option value="M Impressions">M Impressions</option>
                                                            <option value="pallet">Pallet</option>
                                                            <option value="container">Container</option>
                                                            <option value="ft">Ft</option>
                                                            <option value="cases">Cases</option>
                                                        </select>
                                                    </div>

                                                    <template v-if="index > 0">
                                                        <a href="javascript:void(0)" v-on:click="removeProduct(index)"
                                                           class="remove btn btn-danger">Remove</a>
                                                    </template>
                                                </td>
                                                <!--<td>10</td>
                                                <td><span class="pending-text">Pending</span></td>-->
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="text-right">
                                            <a href="javascript:void(0)"   v-on:click="addProduct" class="btn btn-primary" >Add More Item</a>
                                        </div>

                                </div>
                            </div>

                            <div class="row">
                                    <div class="col-lg-6">
                                        <div class="card">
                                            <div class="card-header">
                                               <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <h5 class="card-title flex-grow-1 mb-0">Add Attachment</h5>
                                                    </div>
                                               </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="add-attachment-section">
                                                    <div class="add-attachment">

                                                        <div class="form-group files">
                                                            <vue-dropzone :options="dropzoneOptions"
                                                                        :id="'attachment-dropzone'"
                                                                        v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                                            </vue-dropzone>
                                                        </div>
                                                    </div>
                                                    <!--<div class="add-file">
                                                        <div  class="pdf-dwn-sec">
                                                            <div  class="d-flex p-2">
                                                                <div  class="add-file-left flex-grow-1">
                                                                    <div class="d-flex ">
                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(quote_attachment)"></i></span>
                                                                        <div class="filename-col">
                                                                            <div class="name-input">
                                                                                <span class="file-name" v-if="quote_attachment.id != attachment_edit_id">{{quote_attachment.edited_file_name}}</span>
                                                                                <div class="d-flex editname" v-if="quote_attachment.id == attachment_edit_id">
                                                                                    <div>
                                                                                        <input type="text" class="form-control" placeholder="" v-model="quotationData.quote_attachments[index].edited_file_name">
                                                                                        <a href="javascript:void(0);" @click="renameQuoteFile(quote_attachment.edited_file_name, quote_attachment.id, index)" class="text-primary" style="font-size: 18px"><i class="ri-save-3-fill"></i></a>
                                                                                        <a href="javascript:void(0);" @click="attachment_edit_id = null" class="text-danger" style="font-size: 18px"><i class="ri-close-line"></i></a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <small class="light-clr">{{quote_attachment.size}}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="file-remv-btn flex-shrink-0 ms-2">
                                                                    <div  class="d-flex gap-1">
                                                                        <a  href="javascript:void(0)" class=" download-btn" style="font-size: 18px;"><i  class="ri-download-2-line"></i></a>
                                                                        <div class="btn-group">
                                                                            <button  type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-icon text-muted btn-sm fs-18 dropdown-toggle" style="font-size: 18px;">
                                                                            <i  class="ri-more-fill"></i>
                                                                            </button>
                                                                            <ul  class="dropdown-menu">
                                                                                <li ><a  href="javascript:void(0);" class="dropdown-item"><i  class="ri-pencil-fill align-bottom me-2 text-muted"></i> Rename</a></li>
                                                                                <li ><a  href="javascript:void(0);" class="dropdown-item"><i  class="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete</a></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>-->
                                                </div>
                                                <!-- end dropzon-preview -->
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-6">
                                        <div class="card panel notes-row">
                                            <div class="card-header">
                                               <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <h5 class="card-title flex-grow-1 mb-0">Notes</h5>
                                                    </div>
                                               </div>
                                            </div>
                                            <div class="card-body">

                                                <div class="form-group">
                                                    <template v-for="(note, index) in form.notes">
                                                        <textarea v-model="form.notes[index]"  class="form-control"
                                                                placeholder=""></textarea>
                                                    </template>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                        </div>
                    </div>


                    <div class="btnrow text-right">
                        <router-link class="btn btn-danger" :to="{name: 'quotations'}" :disabled="loading || saveDone == true">Cancel
                        </router-link>
                        <button type="button" v-on:click="saveAsDraft" class="btn btn-info ml-1" :disabled="loading || saveDone == true">
                            Save As Draft
                        </button>
                        <button type="submit" class="btn btn-success ml-1" ref="submitButton" :disabled="loading || saveDone == true">Save Quotation</button>
                    </div>

                </form>
            </ValidationObserver>

        </div>


        <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                                2022 © Superb.
                            </div>
                            <div class="col-sm-6">
                                <div class="text-right d-none d-sm-block">
                                    All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
        <CustomerAddModal @customerDataSaved="customerDataSaved($event)"></CustomerAddModal>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import axios from "axios";
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {debounce} from 'lodash';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {configure, extend, ValidationObserver, ValidationProvider} from 'vee-validate';
import CustomerAddModal from "../../components/CustomerAddModal";
//import VueCkeditor from 'vue-ckeditor2';
import { VueEditor } from "vue2-editor";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "NewQuotation",
    components: {
        VueTypeaheadBootstrap,
        vueDropzone: vue2Dropzone,
        ValidationObserver, ValidationProvider,
        CustomerAddModal,
        //VueCkeditor,
        VueEditor
    },
    created() {

    },
    mounted() {
        this.form = _.cloneDeep(this.newQuotation);
        this.getSettings();
        if (this.form.customer) {
            this.lookupCustomer(this.form.customer.company_name);
        }

        setTimeout(() => {
            this.isItReady = true;
        }, 50);
    },
    data() {
        return {
            isItReady: false,
            settings: {
                quote_number: null,
                sale_users: [],
                countries: [],
                draft_count: 0,
                max_products: 0,
                max_tiers: 0
            },
            form: {
                parent_quote: null,
                quote_number: null,
                is_draft: null,
                quote_name: null,
                customer_id: null,
                customer: null,
                sale_rep: null,
                files_attached: [],
                notes: [""],
                products: [
                    {
                        product_id: null,
                        product: null,
                        product_num: null,
                        name: null,
                        description: null,
                        quantity_unit: 'bags',
                        is_master_product_modify: false,
                        tiers: [
                            {
                                tier: null,
                                sku: null
                            },
                            {
                                tier: null,
                                sku: null
                            },
                            {
                                tier: null,
                                sku: null
                            }
                        ],
                    }
                ],

            },
            selectedCustomer: null,
            searchCustomer: null,
            customers: [],
            customerData: null,
            searchProduct: null,
            products: [],
            dropzoneOptions: {
                url: window.route('quote.addAttachments'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 10,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            submitted: false,
            saveDone: false,
            editorConfigMin: {
                toolbar: [],
                ui: { top: 10, right: 10, bottom: 10, left: 10}
            },
            editorConfigMin2: {
                "modules": {
                    "toolbar": false
                }
            },
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewQuotation'
        ]),
        tierNumberFormat(index, tierIndex){
            // console.log('tier', this.form.products[index].tiers[tierIndex].tier);
            let tier = this.form.products[index].tiers[tierIndex].tier.replace(',', '');
            if(!isNaN(tier)) {
                //console.log('is number');
                let nfObject = new Intl.NumberFormat('en-US');
                this.form.products[index].tiers[tierIndex].tier = nfObject.format(tier);
                //this.form.products[index].tiers[tierIndex].tier = tier.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        },
        customerDataSaved(customer){
            if (customer) {
                this.form.customer_id = customer.id;
                //this.customerForm.customer = customer;
                let html = '<div>' + customer.company_name + '</div>';
                if(customer.customer_contacts && customer.customer_contacts.length > 0) {
                    html = '<div>' + customer.customer_contacts[0].contact_name + '</div>' + '<div class="short_text">Company:'+ customer.company_name + '</div>';
                }
                this.form.customer = {
                    id: customer.id,
                    sales_rep_id: customer.sales_rep_id,
                    text: '<div>' + customer.company_name + '</div>',
                    name: '<div>' + customer.company_name + '</div>',
                    html: html,
                };
            }
        },
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }
                this.saveQuotation();
            });
        },
        afterUploadComplete(file, response) {
            this.form.files_attached.push({
                name: response.name,
                size: response.size,
                src: response.src,
                image_type: response.image_type,
                attachment_id: response.attachment_id
            });
            this.setNewQuotation(this.form);
            this.setSuccessMessage(response.message);
            setTimeout(() => {
                this.setSuccessMessage(null);
            }, 5000);
        },
        saveAsDraft() {
            this.$confirm(
                {
                    message: `Do you want to save as Draft?`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    },
                    callback: confirm => {
                        if (confirm) {
                            this.form.is_draft = 1;
                            this.setNewQuotation(this.form);
                            this.$refs.submitButton.click();
                            // this.saveQuotation();
                        }
                    }
                }
            )
        },
        saveQuotation() {
            if (this.saveDone) {
                self.setSuccessMessage('Already saved!');
                return false;
            }
            let self = this;
            this.submitted = true;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let url = window.route('quotations.store');
            if(this.form.parent_quote) {
                url = window.route('saveCloneQuote');
            }

            return axios.post(url, this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                        this.submitted = false;
                    } else {
                        self.saveDone = true;
                        self.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                            if (this.form.is_draft == 1) {
                                //self.$router.push({name: 'draft'});
                                self.$router.push({name: 'viewQuote', params: {id: data.id}});
                            } else if(data.id) {
                                self.$router.push({name: 'viewQuote', params: {id: data.id}});
                            } else {
                                self.$router.push({name: 'quotations'});
                            }

                        }, 10);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                    this.submitted = false;
                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSettings() {
            console.log(this.form.quote_number)
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.settings'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.settings = data.data;

                        if(this.form.quote_number != null && this.form.quote_number != "") {

                        } else {
                            this.form.quote_number = this.settings.quote_number;
                        }


                        this.setNewQuotation(this.form);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getCustomerDetail(customer_id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('searchCustomerDetails'), {customer_id: customer_id}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.customerData = data.data.customer_data;
                        if (data.data.customer_data.sales_rep_id) {
                            this.form.sale_rep = data.data.customer_data.sales_rep_id;
                        }
                        if(this.form.quote_number != null && this.form.quote_number != "") {

                        } else {
                            this.form.quote_number = data.data.quote_number;
                        }

                        this.setNewQuotation(this.form);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

        addNewTier(index) {
            if(this.settings && this.settings.max_tiers != null &&
                this.form.products[index].tiers.length == this.settings.max_tiers) {
                this.setErrorMessage('Max '+this.settings.max_tiers+' Tiers allowed in Single product');
                setTimeout(() => {
                    this.setErrorMessage(null);
                }, 5000);

                return;
            }
            this.form.products[index].tiers.push({
                tier: null,
                sku: null
            });
            this.setNewQuotation(this.form);
        },
        removeTier(index, tierIndex) {
            this.form.products[index].tiers.splice(tierIndex, 1);
            this.setNewQuotation(this.form);
        },
        addProduct() {
            if(this.settings && this.settings.max_products != null &&
                this.form.products.length == this.settings.max_products) {
                this.setErrorMessage('Max '+this.settings.max_products+' Product allowed in Quote');
                setTimeout(() => {
                    this.setErrorMessage(null);
                }, 5000);

                return;
            }
            this.form.products.push({
                product_id: null,
                product: null,
                product_num: null,
                name: null,
                description: null,
                quantity_unit: 'bags',
                tiers: [
                    {
                        tier: null,
                        sku: null
                    },
                    {
                        tier: null,
                        sku: null
                    },
                    {
                        tier: null,
                        sku: null
                    }
                ],
            });
            this.setNewQuotation(this.form);
        },
        removeProduct(index) {
            this.form.products.splice(index, 1);
            this.setNewQuotation(this.form);
        },
        onProductSelect(event, index) {
            if (event != null) {
                this.form.products[index].product_id = event.id;
                //let product = this.products.find((x) => x.id == event.id);
                if (this.form.products[index].name == null) {
                    this.form.products[index].name = event.product_name;
                }
                if (this.form.products[index].description == null) {
                    this.form.products[index].description = event.product_desc;
                }
            } else {
                this.form.products[index].product_id = null;
            }
            this.setNewQuotation(this.form);
        },
        onProductDeSelect(event) {
            //console.log(event)
            this.setNewQuotation(this.form);
        },
        onProductSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchProductNew(loading, search, this);
            }
        },
        searchProductNew: _.debounce((loading, search, vm) => {
            return axios.get(window.route('so.products.search', {
                page: 1,
                exclude_products: [],
                search_filter: search,
                status_filter: null
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.products = data.data.products.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 500),

        onCustomerSelect(event) {
            if (event) {
                this.form.customer_id = event.id;
            } else {
                this.form.customer_id = null;
            }
            this.setNewQuotation(this.form);
        },
        onCustomerDeSelect(event) {
            this.form.customer_id = null;
            this.setNewQuotation(this.form);
        },
        onCustomerSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchCustomer'), {searchTerm: search, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        lookupCustomer(searchTerm) {
            let self = this;
            //this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('searchCustomer'), {searchTerm: searchTerm, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.customers = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    //self.setLoading(false);

                });
        }
    },
    beforeDestroy() {
        let form = {
            quote_number: null,
            is_draft: null,
            quote_name: null,
            customer_id: null,
            customer: null,
            sale_rep: null,
            files_attached: [],
            notes: [""],
            products: [
                {
                    name: null,
                    description: null,
                    quantity_unit: 'bags',
                    tiers: [
                        {
                            tier: null,
                            sku: null
                        },
                        {
                            tier: null,
                            sku: null
                        },
                        {
                            tier: null,
                            sku: null
                        }
                    ],
                }
            ],

        };
        this.setNewQuotation(form);
    },

    computed: {
        ...mapState([
            'userState',
            'quotationState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'newQuotation',
            'loading'
        ])
    },
    watch: {
        'form.customer_id': {
            handler: function (after, before) {
                if (after) {
                    this.getCustomerDetail(after);
                }
            },
            deep: true,
        },
        'form.customer': {
            handler: function (after, before) {
                if (after) {
                    //console.log(after)
                    this.form.customer_id = after.id;
                }
            },
            deep: true,
        },
        'form.quote_number': {
            handler: function (after, before) {
                if (after) {
                    // console.log(after)
                }
            },
            deep: true,
        },
        'form.products': {
            handler: function (after, before) {
                if (after) {
                    //console.log('form.products', after)
                }
            },
            deep: true,
        },
    }
}
</script>

<style scoped>
.special-input-class {
    background-color: black !important;
    color: white !important;
}

.special-highlight-class {
    font-weight: 900;
    color: #585656;
}

img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
}

.d-center {
    display: flex;
    align-items: center;
}

.selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
}

.v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
    border-bottom: none;
}

.v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
    color: #fff;
}

.error {
    color: red;
}
</style>
